export default __webpack_public_path__ + "static/media/xmines_nathanyell_happy.2aaab90d.mp3";